import { TLKeyboardEvent, TLKeyboardEventInfo, SelectTool as TLSelectTool } from '@tldraw/tldraw'
import { Mask } from './childStates/Mask/Mask'
import { Masking } from './childStates/Masking'
import { PointingMaskHandle } from './childStates/PointingMaskHandle'
import { Measuring } from './childStates/Measuring'
import { Resizing } from './childStates/Resizing'

// @ts-ignore
export class SelectTool extends TLSelectTool {
  static override children = () => [
    ...TLSelectTool.children(),
    // Add your own tools here
    Mask,
    Masking,
    PointingMaskHandle,
    Measuring,
    Resizing,
  ]

  override onKeyDown: TLKeyboardEvent = (info: TLKeyboardEventInfo) => {
    if (info.key === 'Alt' && !!this.editor.getOnlySelectedShape()) {
      this.editor.setCurrentTool('select.measuring')
    }
  }
}
